export default __webpack_public_path__ + "media/pro/locked-3a74a09d.svg";